import React, { useState, useEffect } from "react";
import { Container, Card, Table, Button, Badge } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { getAllIssuesApi, cancelIssueApi } from "../menu/service/api_service";
import NewIssueModal from "./NewIssueModal";
import ViewIssueModal from "./ViewIssueModal";
import Swal from "sweetalert2";

export default function IssueItems() {
  const token = localStorage.getItem("token");
  
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  useEffect(() => {
    fetchIssues();
  }, []);

  const fetchIssues = async () => {
    try {
      setLoading(true);
      const res = await getAllIssuesApi(token);
      setIssues(res.data || []);
    } catch (error) {
      console.error("Failed to fetch issues:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString('th-TH');
  };

  const handleCancelIssue = async (id) => {
    try {
      const res = await Swal.fire({
        title: "แน่ใจหรือไม่?",
        text: "เมื่อยกเลิกแล้ว สต๊อกจะถูกคืนเข้าสู่ระบบและไม่สามารถย้อนกลับได้",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ยกเลิกใบเบิก",
        cancelButtonText: "ปิด"
      });

      if (res.isConfirmed) {
        setLoading(true);
        await cancelIssueApi(token, id);
        await Swal.fire("สำเร็จ", "ยกเลิกใบเบิกเรียบร้อยแล้ว", "success");
        setShowViewModal(false);
        fetchIssues();
      }
    } catch (err) {
      Swal.fire("ข้อผิดพลาด", err.response?.data?.message || err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="px-3 py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0" style={{ color: "#1e3c72" }}>Issue Documents</h4>
        <Button 
          variant="primary" 
          style={{ background: "#1e3c72", border: "none" }}
          onClick={() => setShowModal(true)}
        >
          <FaPlus className="me-2" />
          New Issue
        </Button>
      </div>

      <Card className="shadow-sm border-0">
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th className="py-3 px-4 border-0">Document No.</th>
                  <th className="py-3 px-4 border-0">Issue Date</th>
                  <th className="py-3 px-4 border-0">Reason</th>
                  <th className="py-3 px-4 border-0">Issued Items</th>
                  <th className="py-3 px-4 border-0 text-end">Total Cost (฿)</th>
                  <th className="py-3 px-4 border-0">Created By</th>
                </tr>
              </thead>
              <tbody>
                {issues.length > 0 ? (
                  issues.map(doc => (
                    <tr 
                      key={doc.id} 
                      style={{ cursor: "pointer" }}
                      onClick={() => { setSelectedDoc(doc); setShowViewModal(true); }}
                    >
                      <td className="px-4 fw-bold text-primary">#ISSUE-{doc.id}</td>
                      <td className="px-4 text-muted">{formatDate(doc.created_at)}</td>
                      <td className="px-4">
                        {doc.reason && doc.reason.startsWith('Transfer to branch') ? (
                          <Badge bg="info" className="px-2 py-1 me-2">Auto (Transfer)</Badge>
                        ) : null}
                        <Badge bg="secondary" className="px-2 py-1">{doc.reason}</Badge>
                        {doc.status === 'cancelled' && <Badge bg="danger" className="ms-2 px-2 py-1">Cancelled</Badge>}
                      </td>
                      <td className="px-4">
                        <ul className="mb-0 ps-3">
                          {doc.items && doc.items.map(item => (
                            <li key={item.id} className="text-muted small">
                              {item.name} <span className="text-primary fw-bold">x{item.quantity} {item.unit || ''}</span> 
                              (฿{Number(item.cost).toFixed(2)})
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td className="px-4 text-end fw-bold text-danger">
                        {Number(doc.total_cost).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                      </td>
                      <td className="px-4">{doc.created_by_name || 'System'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      No issue documents found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <NewIssueModal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        onSuccess={fetchIssues}
      />

      <ViewIssueModal 
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        doc={selectedDoc}
        onCancel={handleCancelIssue}
      />
    </Container>
  );
}
